// project import
import dashboard from './dashboard';
import administracion from './administracion';
import clientes from './clientes';
import rutas from './rutas';
import prestamos from './prestamos';
import recaudo from './recaudo';
import reports from './reports';
import cajas from './cajas';

// ==============================|| MENU ITEMS ||============================== //
// Módulos de negocio (Administración, Clientes, Rutas, Préstamos, Recaudo) se
// agregan aquí a medida que cada uno tiene sus páginas construidas. Cada item de
// módulo declara `permission` (código o array) y Navigation los filtra en runtime.

const menuItems = {
  items: [dashboard, administracion, clientes, rutas, prestamos, recaudo, cajas, reports]
};

export default menuItems;
